import { FormModeConfig, FormModeDefaults } from '../../../base/interfaces/formModes'
import { ArticuloRecetaInputProps } from '../interfaces/articuloReceta'

export type ArticuloRecetaFormMode = 'create' | 'edit' | 'consult'

export const articuloRecetaFormModeDefault: FormModeDefaults<ArticuloRecetaFormMode> = {
  create: { disabled: false, readOnly: false },
  edit: { disabled: false, readOnly: false },
  consult: { disabled: true, readOnly: true },
}

export const articuloRecetaFormModeConfig: FormModeConfig<ArticuloRecetaInputProps, ArticuloRecetaFormMode> =
  {
    articulo: {
      create: { disabled: false },
      edit: { disabled: true, hidden: true },
      consult: { disabled: true },
    },
  }
